import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { MindfullMark } from '@/components/brand/MindfullMark';
import { Hero, Story } from '@/components/landing';

/**
 * The homepage, in two sections: a live board (Hero) and one pinned scroll
 * scene that ends in the waitlist and footer (Story).
 */
const Landing = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  // Signed-in people go straight to their canvas
  useEffect(() => {
    if (!isLoading && user) navigate('/canvas');
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-paper text-ink-3">
        <MindfullMark size={32} motion="loop" title="Loading" />
      </div>
    );
  }

  return (
    <main className="scrollable-page min-h-screen bg-paper">
      <Hero />
      <Story />
    </main>
  );
};

export default Landing;
